/* eslint-disable import/no-unresolved,import/extensions */
import React from 'react';
import { Form } from 'antd';

/* eslint-disable react/prop-types */

const FieldTemplate = (props) => {
  const {
    id,
    classNames,
    label,
    help,
    required,
    description,
    errors,
    children,
    displayLabel,
    formContext,
  } = props;
  // object fields display the description themselves
  // for all other fields, we need to display it before children
  const itemDesc = props.schema.type !== 'object' ? description : null;

  const hasErrors = props.rawErrors && props.rawErrors.length > 0;

  const isPaginatedOrChatMode = formContext && (formContext.displayMode === 'chat' || formContext.displayMode === 'paginated');

  const fieldClassNames = `${classNames || ''} ${hasErrors ? 'has-error' : ''} ${isPaginatedOrChatMode ? 'hidden' : ''}`;

  const isChatMode = formContext && formContext.displayMode === 'chat';

  const isNullField = props.schema.type === 'null';
  const isPageBreak = props.uiSchema && props.uiSchema['ui:type'] === 'pageBreak';
  const isSpecialField = props.uiSchema && (
    props.uiSchema['ui:type'] === 'heading' ||
    props.uiSchema['ui:type'] === 'paragraph' ||
    props.uiSchema['ui:type'] === 'pageBreak'
  );

  // Extract the parent key from the field's id
  // (e.g., "root_text-1" -> "text-1", "s1_num-question" -> "num-question")
  let fieldKey = '';
  if (id) {
    if (id !== 'root' && !/^root_s\d+$/.test(id)) {
      fieldKey = id.replace(/.*_/, '');
    }
  }

  if (isPageBreak) {
    return null;
  }

  let content;
  if (displayLabel) {
    if (isChatMode) {
      // In chat mode, render label and description outside Form.Item
      const labelAndDescription = (
        <div className="field-description hidden" data-field-key={fieldKey}>
          {label.length && label.trim() !== '' && (
            <div className="ant-col ant-form-item-label">
              {/* eslint-disable-next-line jsx-a11y/label-has-for */}
              <label htmlFor={id} className="" title={`${label}${required ? '*' : ''}`}>
                {label}{required ? '*' : ''}
              </label>
            </div>
          )}
          {itemDesc}
        </div>
      );

      // Only render Form.Item if this is not a null/special field
      if (isNullField || isSpecialField) {
        content = labelAndDescription;
      } else {
        content = (
          <React.Fragment>
            {labelAndDescription}
            <Form.Item id={id} className={fieldClassNames} data-field-key={fieldKey}>
              {children}
              {errors}
            </Form.Item>
          </React.Fragment>
        );
      }
    } else {
      const formItemChildren = [itemDesc, ...children];

      content = (
        <Form.Item label={`${label}${required ? '*' : ''}`} id={id} className={fieldClassNames} data-field-key={fieldKey}>
          {formItemChildren}
        </Form.Item>
      );
    }
  } else if (hasErrors) {
    const divChildren = isChatMode ? [itemDesc, ...children, errors] : [itemDesc, ...children];

    content = <div className={`has-error ${classNames || ''}`} data-field-key={fieldKey}>{divChildren}</div>;
  } else {
    content = [itemDesc, ...children];
  }

  if (isChatMode) {
    return (
      <React.Fragment>
        {content}
        {help}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {content}
      {errors}
      {help}
    </React.Fragment>
  );
};

export default FieldTemplate;
